export default __webpack_public_path__ + "static/media/spot.7b3b95ad.md";